import { Outlet, useLocation, Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useEventListener } from "ahooks";
import { message } from "antd";
// header
import Header from "@/components/Header";
import HeaderAccount from "@/components/HeaderAccount";
import Footer from "@/components/FooterNew";

// components
import { UserStatusComponent } from "@/components/UserStatus";

import { alonePath, unLoginHeader, unFooterPath } from "@/utils/base";

import api from "@/api";
import dataJson from "@/../public/data.json";

import "animate.css";
import "./index.less";
import { getServiceVal } from "@/utils/cookies";
import messageDispatchCenter from "@/utils/messageDispatchCenter";
import { MESSAGE_ON_TYPE } from "@/types/message";
import { downloadHit } from "../freeDownload/interactive";

const CSS_PREFIX = "portal";

function Portal() {
  const scrollRef = useRef<any>(null);
  const startPos = useRef<number | null>(null);
  const endPos = useRef<number | null>(null);
  const [messageApi,contextHolder]=message.useMessage();
  const location = useLocation();
  const { pathname } = location;
  const dispatch = useDispatch();
  const isPageLoad=useRef<boolean>(false);
  const timerRef= useRef<any>(null);
  const userDataChange = useSelector((state: any) => state.userDataChange);

  const getUserDetail = async () => {
    if(!getServiceVal('Authorization')) return ;
    const res: any = await api.getUserDetail();
    if (res.code === 200) {
      dispatch({
        type: "setUserData",
        payload: res.data,
      });
    }
  };
  // 滚动事件监听
  useEventListener(
    "scroll",
    (e) => {
      endPos.current = scrollRef.current.scrollTop;
      dispatch({
        type: "setScrollHeight",
        payload: endPos.current,
      });

      if (endPos.current! > startPos.current!) {
        dispatch({
          type: "setScrollDirection",
          payload: "down",
        });
      } else {
        dispatch({
          type: "setScrollDirection",
          payload: "up",
        });

        dispatch({
          type: "setScrollDistance",
          payload: Math.abs(endPos.current! - startPos.current!),
        });
      }

      startPos.current = endPos.current;

      messageDispatchCenter.emit(MESSAGE_ON_TYPE.SCROLL, e);
    },
    { target: scrollRef }
  );

  useEffect(() => {
    userDataChange > 0 && getUserDetail();
  }, [userDataChange]);
  useEffect(() => {
    window.message=messageApi;
  },[]);
    useEffect(()=>{
      try {
        if(isPageLoad.current) {
          //页面切换 上报pv统计
          timerRef.current && clearTimeout(timerRef.current);
          timerRef.current=setTimeout(()=>{
            const url= window.location.pathname+window.location.search;
            downloadHit(url);
            timerRef.current=null;
            console.log('location--2', window.location,location);
          },300)
        }else{
          //首次加载  不上报pv统计
          isPageLoad.current=true;
        }
      } catch (error) {
        console.error(error);
      }

    },[location])
  return (
    <div className={CSS_PREFIX} id={CSS_PREFIX} ref={scrollRef}>
      {contextHolder}
      {/* <Header /> */}
      {/* <HeaderAccount /> */}
      {alonePath.some((path) => pathname.indexOf(path) > -1) ? null : unLoginHeader.some(
          (path) => pathname.indexOf(path) > -1
        ) ? (
        <HeaderAccount />
      ) : (
        <Header />
      )}
      <UserStatusComponent>
        <Outlet />
      </UserStatusComponent>
      
      {alonePath.some((path) => pathname.indexOf(path) > -1) ||
      unLoginHeader.some((path) => pathname.indexOf(path) > -1) ||
      unFooterPath.some((path) => pathname.indexOf(path) > -1) ? null : (
        <Footer />
      )}
      {/* {alonePath.some((path) => pathname.indexOf(path) > -1) ? null : (
        <Tooltip
          placement="left"
          color="#fff"
          title={
            <div className={`${CSS_PREFIX}-tooltip`}>
              {home.fixed_list.map((item: any) => {
                return (
                  <Link key={item.key} to={`${publicPath}service_support`}>
                    {item.title}
                  </Link>
                );
              })}
            </div>
          }
        >
          <div className={`${CSS_PREFIX}-phone-div`}>
            <PhoneOutlined style={{ transform: "scaleX(-1)", fontSize: 24 }} />
          </div>
        </Tooltip>
      )} */}
    </div>
  );
}

export default Portal;
